<template>
  <div class="not-found">
    <h1>404 - Page Not Found</h1>
    <p>Oops! The page you are looking for does not exist.</p>
    <!-- <router-link to="/">Go back to Home</router-link> -->
  </div>
</template>

<script>
export default {
  name: 'NotFound',


  
//   beforeRouteEnter(to, from, next) {
//       console.info('88888')
//         console.info(to)

//     // if (to.path === '/sss/cc') {
//     //   next('/ccc/dd'); // 重定向到 /ccc/dd
//     // } else {
//     //   next(); // 继续路由
//     // }
//   }
}
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 50px;
}

h1 {
  font-size: 2em;
  color: #333;
}

p {
  font-size: 1.2em;
}

router-link {
  text-decoration: none;
  color: #42b983;
}
</style>